export default {
    // Navbar
    nav: {
      home: 'Home',
      about: 'About Me',
      strategies: 'Strategies',
      performance: 'Performance',
      portfolioBuilder: 'Portfolio Builder',
      insights: 'Insights',
      reports: 'Weekly Reports',
      terminal: 'Quant Lab',
      contact: 'Contact',
      institutional: 'Institutional Investors',
    },
    
    // Home Page
    home: {
      ticker: {
        subtitle: 'Quantitative Trading · Systematic Strategies',
      },
      hero: {
        title: 'HMA Quant Strategies',
        description: 'Quantitative Analyst developing algorithmic strategies with annualized returns exceeding',
        cagr: '40% CAGR',
        and: 'and',
        sharpe: 'Sharpe > 1.5',
        additionalPrefix: 'With',
        drawdowns: 'drawdowns',
        additionalMiddle: 'under',
        drawdownValue: '15%',
        additionalAnd: 'and historical data spanning over',
        years: '20 years',
        ctaPrimary: 'Explore Strategies',
        ctaSecondary: 'About Me',
      },
      featured: {
        label: 'Featured Strategy',
        cta: 'Explore ARES →',
      },
      tech: {
        label: 'Quantitative Infrastructure',
        title: 'MATHEMATICAL & ',
        titleAccent: 'COMPUTATIONAL TOOLS',
        footer: 'Systematic strategies validated through rigorous backtesting on institutional-grade data',
      },
      timeline: {
        label: 'Professional Journey',
        title: 'CAREER ',
        titleAccent: 'MILESTONES',
        milestones: [
          {
            title: 'Physics Degree',
            description: 'University degree completion with specialization in theoretical physics and applied mathematics.',
          },
          {
            title: 'Master in Quantitative Finance',
            description: 'Specialized training in mathematical modeling, quantitative analysis and algorithmic strategy development.',
          },
          {
            title: 'Hedge Fund + Algorithmic Strategy',
            description: 'Started at Spanish hedge fund. Development and implementation of algorithmic dividend-based strategy.',
          },
          {
            title: 'IG Group (FTSE 100)',
            description: 'Joined IG Group broker, FTSE 100 component, working in quantitative development.',
          },
          {
            title: 'Strategies in Production',
            description: 'Multiple algorithmic strategies deployed in production with real capital. Systematic trading portfolio operational.',
          },
        ],
      },
      features: {
        title: 'Why invest with quantitative strategies?',
        subtitle: 'Algorithmic systems based on data, rigorous backtesting and institutional risk management',
        items: [
          {
            title: 'Momentum & Timing',
            description: '+40% CAGR in momentum and market timing strategies validated over 15 years of historical data'
          },
          {
            title: 'Bayesian Models',
            description: 'Hidden Markov Models for market regime detection and dynamic adaptation'
          },
          {
            title: 'Market Neutral',
            description: 'Long-short strategies with Beta/R² correlational analysis to reduce directional exposure'
          },
          {
            title: 'Automated Systems',
            description: 'Fully automatable intraday trading in prop firms and institutional brokers'
          },
          {
            title: 'Multi-Asset',
            description: 'US equities, indices, crypto, volatility (VIX) - real diversification'
          },
          {
            title: 'Institutional Track Record',
            description: 'Experience managing portfolios up to $200M at hedge funds and FTSE 100 brokers'
          }
        ]
      },
      cta: {
        title: 'Ready to get started?',
        subtitle: 'Discover my strategies on Darwinex, eToro and Wikifolio, or read my quantitative analysis on Substack',
        ctaPrimary: 'Where to Invest',
        ctaSecondary: 'Contact'
      }
    },

    // About Me Page
    about: {
      title: 'Quantitative Analyst',
      intro1: 'Quantitative Analyst with a background in',
      physics: 'Physics (BSc)',
      and: 'and',
      finance: 'quantitative finance (MSc)',
      intro2: '. Currently works at a London-based broker (FTSE 100), developing statistical models and systematic trading strategies.',
      intro2b: 'Currently a CFA (Chartered Financial Analyst) candidate — the most prestigious and globally recognized certification in the investment industry.',
      intro3: 'With previous experience managing portfolios of up to',
      amount: '$200M at a Spanish hedge fund',
      intro4: ', and in pricing and risk management of energy derivatives at a commodities fund, combines mathematical rigor, machine learning and deep market knowledge to build robust and reproducible algorithms.',
      trackRecordTitle: 'Track Record',
      trackRecordDescription: 'Building quantitative strategies that deliver consistent risk-adjusted returns across market regimes. Our track record speaks through the numbers: independent strategies designed to minimize drawdowns while maximizing alpha, each stress-tested across decades of historical data and validated through live paper and real trading. Individually, each strategy targets controlled risk within its asset class. Combined into a diversified portfolio, they achieve Sharpe ratios above 1.5 and maximum drawdowns contained below -15%, with near-zero correlation to traditional benchmarks. From momentum-driven equity portfolios to market-neutral statistical arbitrage, from volatility harvesting to quantitative macro, whether you\'re a retail investor looking for systematic exposure or an institution seeking uncorrelated return streams, we build strategies that adapt to your risk profile and objectives.',
      trackRecordParagraph1: 'Building quantitative strategies that deliver consistent risk-adjusted returns across market regimes. Professional experience includes optimizing systematic strategies, improving risk-adjusted returns from 12% to 23% annualized, and contributing to portfolio management and research covering assets under management exceeding €200M.',
      trackRecordParagraph2: 'Designed and backtested over 40 quantitative models across equities, derivatives, and fixed income. Each strategy stress-tested across decades of historical data, as well as validated through live paper trading and real market conditions.',
      trackRecordParagraph3: 'Individually, each strategy targets controlled risk within its asset class. Combined into a diversified portfolio, they achieve Sharpe ratios above 1.5 and maximum drawdowns contained below -15%, with near-zero correlation to traditional benchmarks.',
      trackRecordDisclaimer: 'Performance figures based on backtesting and live paper trading. Past results do not guarantee future performance. All returns are hypothetical unless explicitly stated as live.',
      trackRecordParagraph4: 'From momentum-driven equity portfolios to market-neutral statistical arbitrage, from volatility harvesting to quantitative macro, whether you\'re a retail investor looking for systematic exposure or an institution seeking uncorrelated return streams, we build strategies that adapt to your risk profile and objectives.',
      expertiseTitle: 'Expertise',
      expertise: [
        '+40% CAGR in momentum and timing strategies',
        'Bayesian models with Hidden Markov Models for regime detection',
        'Market neutral strategies with Beta/R² correlational analysis',
        'Fully automatable intraday systems for prop firms',
        'Multi-asset: US equities, indices, crypto, volatility (VIX)',
        'Institutional track record: portfolio management up to $200M',
      ],
      toolsTitle: 'Mathematical & Computational Tools',
      toolsSubtitle: 'Technologies and frameworks I use for quantitative research and systematic trading',
      clickToFlip: 'Click to flip',
      clickToFlipBack: 'Click to flip back',
      clickForDetails: 'Click for more details →',
      clickToClose: 'Click to close ←',
      tools: {
        python: {
          name: 'Python',
          description: 'Primary language for backtesting, statistical analysis and strategy development'
        },
        numpy: {
          name: 'NumPy',
          description: 'Fundamental package for numerical computing and array operations'
        },
        pandas: {
          name: 'Pandas',
          description: 'High-performance data manipulation and analysis for time series'
        },
        scikit: {
          name: 'Scikit-learn',
          description: 'Machine learning models for pattern recognition and predictive analytics'
        },
        tensorflow: {
          name: 'TensorFlow',
          description: 'Deep learning framework for complex market behavior modeling'
        },
        pytorch: {
          name: 'PyTorch',
          description: 'Dynamic neural networks for advanced deep learning research'
        },
        git: {
          name: 'Git',
          description: 'Version control for code management and collaborative development'
        },
        vscode: {
          name: 'VS Code',
          description: 'Professional IDE for efficient code development and debugging'
        },
        jupyter: {
          name: 'Jupyter',
          description: 'Interactive notebooks for research, visualization and strategy prototyping'
        },
        quantlib: {
          name: 'QuantLib',
          description: 'Quantitative finance library for derivatives pricing and risk management'
        },
        backtrader: {
          name: 'Backtrader',
          description: 'Python framework for backtesting and live trading strategies'
        },
        postgresql: {
          name: 'PostgreSQL',
          description: 'Robust relational database for structured financial data storage'
        },
        mongodb: {
          name: 'MongoDB',
          description: 'NoSQL database for flexible unstructured market data storage'
        },
        docker: {
          name: 'Docker',
          description: 'Containerization for consistent deployment across environments'
        },
        aws: {
          name: 'AWS',
          description: 'Cloud infrastructure for scalable computing and data processing'
        },
        mathematics: {
          name: 'Mathematics',
          description: 'Advanced mathematical concepts underlying quantitative finance'
        },
        statistics: {
          name: 'Statistics',
          description: 'Statistical methods for hypothesis testing and inference'
        },
        linearalgebra: {
          name: 'Linear Algebra',
          description: 'Matrix operations for portfolio optimization and factor models'
        },
        timeseries: {
          name: 'Time Series',
          description: 'Temporal data analysis for forecasting and trend detection'
        },
        calculus: {
          name: 'Calculus',
          description: 'Derivatives and integrals for option pricing and optimization'
        },
        probability: {
          name: 'Probability',
          description: 'Probabilistic models for risk assessment and decision making'
        },
        optimization: {
          name: 'Optimization',
          description: 'Mathematical optimization for portfolio allocation and strategy tuning'
        },
        bayesian: {
          name: 'Bayesian',
          description: 'Bayesian inference for regime detection and parameter estimation'
        },
        montecarlo: {
          name: 'Monte Carlo',
          description: 'Simulation methods for risk analysis and scenario testing'
        }
      },
      ctaTitle: 'Ready to invest differently?',
      ctaSubtitle: 'Explore my quantitative strategies or get in touch.',
      ctaStrategies: 'View Strategies',
      ctaContact: 'Contact',
      milestones: [
        {
          title: 'Physics Degree',
          description: 'University degree completion with specialization in theoretical physics and applied mathematics.',
          shortDetail: 'Foundations in calculus, linear algebra, quantum mechanics, statistical mechanics, electromagnetism, relativity, and scientific programming in Python/Fortran/C.'
        },
        {
          title: 'Master in Quantitative Finance',
          description: 'Specialized training in mathematical modeling, quantitative analysis and algorithmic strategy development.',
          shortDetail: 'Python programming, econometrics, derivatives, portfolio management, machine learning, deep learning, NLP, reinforcement learning, AWS deployment, and quantum computing.'
        },
        {
          title: 'Hedge Fund',
          description: 'Joined Spanish hedge fund working with top-tier institutional clients.',
          shortDetail: 'Quantitative analyst managing portfolios for Edmond de Rothschild, Millennium and US financial firms. Data-driven studies, process optimization, and quantitative research.'
        },
        {
          title: 'Energy Trading',
          description: 'Trading and risk management in global energy markets for Dutch company.',
          shortDetail: 'Trading opportunities in European energy interconnections. Optimization projects for Repsol, Glencore, TMS. Reuters Eikon, ETRMs development, CPLEX/Gurobi solvers, Monte Carlo pricing.'
        },
        {
          title: 'IG Group (FTSE 100)',
          description: 'Quantitative analyst at FTSE 100 broker, developing ML models for trading optimization and risk management.',
          shortDetail: 'XGBoost/Random Forest models for market maker risk management. Statistical research, PnL pipelines, GCP/BigQuery/Streamlit dashboards. Reporting for London and Melbourne teams.'
        },
        {
          title: 'Strategies in Production',
          description: 'Development and operation of proprietary algorithmic strategies with real capital across multiple asset classes.',
          shortDetail: 'Market neutral, momentum, pair trading, ML-based trading, forex, crypto, volatility strategies. Complete pipeline from hypothesis to live execution. See Strategies section for more details.'
        }
      ],
      eventsTitle: 'EVENTS',
      eventsAttendTitle: 'EVENTS I ATTEND / RECOMMEND',
      eventsOrganizeTitle: 'EVENTS I ORGANIZE / SPEAK AT',
      eventAttending: 'ATTENDING',
      eventOrganizer: 'ORGANIZER',
      eventQuantConference: 'Quant Finance Conference',
      eventQuantConferenceLocation: 'London, June 2026',
      eventQuantConferenceDesc: 'Leading event for quantitative researchers and practitioners. Focus on systematic trading and risk management.',
      eventQuantMeetup: 'Quant Finance Meetup',
      eventQuantMeetupLocation: 'Madrid, 2025',
      eventQuantMeetupDesc: 'Organized community event for quantitative researchers and practitioners. Focus on sharing systematic trading strategies and networking.',
      eventsComingSoon: 'More events coming soon...',
      podcastsTitle: 'PODCASTS · COMING SOON',
      podcastsDescription: 'A series of conversations with practitioners, researchers, and builders in quantitative finance. Currently in planning. If you want to be notified when this launches, subscribe via the contact page.',
      disclaimer: 'The information provided on this site is for educational and informational purposes only. It does not constitute financial, investment, or trading advice. Past performance does not guarantee future results. Always consult with a licensed financial advisor before making any investment decisions.',
    },

    // Strategies Page
    strategies: {
      title: 'Quantitative Strategies',
      subtitle: 'Institutional-grade algorithmic systems with rigorous backtesting',
      compareTitle: 'Performance Comparison',
      compareSubtitle: 'Compare key metrics across all strategies',
      riskLevel: 'Risk Level',
      moderate: 'Moderate',
      high: 'High',
      veryHigh: 'Very High',
      viewStrategy: 'View Strategy',
      equityCurve: 'EQUITY CURVE',
      drawdownAnalysis: 'DRAWDOWN ANALYSIS',
      maxDrawdownComparative: 'MAX DRAWDOWN COMPARATIVE',
      comparativeMetrics: 'COMPARATIVE METRICS',
      correlation: 'CORRELATION',
      correlationWithBenchmarks: 'CORRELATION WITH BENCHMARKS',
      downloadBrochure: '📄 Download Brochure',
      annualReturns: 'Annual Returns',
      historicalDataDisclaimer: '* Historical data period {start} - {end}. Past performance does not guarantee future returns.',
      strategyNames: {
        tyr: 'TYR Strategy',
        ares: 'ARES Strategy',
        ascalafo: 'ASCÁLAFO Strategy',
        deimos: 'DEIMOS Strategy',
        fobos: 'FOBOS Strategy',
        bes: 'BES Strategy',
        janus: 'JANUS Strategy',
        hraesvelgr: 'HRÆSVELGR Strategy',
      },
      metrics: {
        cagr: 'CAGR',
        sharpe: 'Sharpe',
        maxDD: 'Max DD',
        volatility: 'Volatility',
      },
      strategyDescriptions: {
        tyr: 'Dual-momentum rotation',
        ares: 'Market timing',
        ascalafo: 'Double layer',
        deimos: 'Market timing + risk',
        fobos: 'Double layer + risk',
        bes: 'Trend following',
        janus: 'Sector rotation',
        hraesvelgr: 'Aggressive All Weather',
      },
      strategyFullDescriptions: {
        tyr: 'TYR takes its name from the Norse god of order, justice, and protection, a fitting symbol for a strategy designed to navigate markets with discipline and resilience. TYR is a quantitative dual-momentum rotation strategy inspired by the principles behind Ray Dalio\'s All Weather philosophy.',
        ares: 'ARES is a proprietary quantitative market timing strategy. Developed and validated across nearly 20 years of historical data (2006–2026), it has proven robust through the most stressful episodes of modern markets: the 2008 financial crash, the 2020 pandemic, the aggressive 2022 rate hike cycle, and the extreme volatility of 2024–2025.',
        ascalafo: 'Proprietary double-layer market timing strategy on the U.S. market. Two independent signal systems that combine for maximum entry/exit precision. 100% systematic, controlled binary exposure.',
        deimos: 'DEIMOS is a proprietary quantitative market timing strategy with higher controlled risk. Developed and validated across nearly 20 years of historical data (2006–2026), it has proven robust through the most stressful episodes of modern markets. With a more aggressive risk profile than ARES, it seeks to maximize returns in bull markets while maintaining systematic discipline.',
        fobos: 'Proprietary double-layer market timing strategy on the U.S. market with high risk/return profile. Two independent signal systems that combine for maximum entry/exit precision. 100% systematic, controlled binary exposure with optimized leverage for investors with higher risk tolerance.',
        bes: 'BES is a systematic trend-following strategy focused on medium-term growth. It holds names that are technically outrunning the broad market, combining relative strength, momentum and trend stability to filter noise.',
        janus: 'JANUS is a quantitative stock selection system with full weekly rebalancing, operating in Long-Short Market Neutral mode. Its name evokes the Roman god with two faces — exactly the duality of taking long and short positions simultaneously.',
        hraesvelgr: 'HRÆSVELGR is TYR’s more aggressive twin in the All Weather family. Same regime discipline, more appetite for growth, and a faster shift to defence when momentum fades.',
      },
    },

    // Portfolio Builder Page
    portfolioBuilder: {
      title: 'Portfolio Builder',
      subtitle: 'Build your personalized portfolio combining multiple quantitative strategies',
      riskWarning: {
        title: '⚠ RISK WARNING',
        content: 'Quantitative strategies involve risk of capital loss. Historical performance shown is based on backtesting and simulation — it does not guarantee future returns. This is an educational tool, not investment advice, not a recommendation, and not a solicitation to buy or sell any security.',
      },
      hero: {
        heading1: 'BUILD YOUR',
        heading2: 'IDEAL PORTFOLIO',
        description: 'Explore portfolio combinations across our strategies. This tool allows you to simulate allocations, analyze historical metrics, and understand how different strategy weightings affect risk-adjusted returns. This is an educational tool — not personalized investment advice.',
        disclaimer: 'Educational tool only. Simulated results based on historical data. Not investment advice.',
      },
      tabs: {
        build: 'Build Portfolio',
        models: 'Model Portfolios',
        saved: 'Saved Portfolios',
      },
      buildSection: {
        selectTitle: 'Select Strategies',
        selectSubtitle: 'Choose at least 2 strategies to combine',
        weightsTitle: 'Assign Weights',
        weightsSubtitle: 'Total must equal 100%',
        totalWeight: 'Total Weight',
        distributeEqually: 'Distribute Equally',
        optimize: 'Auto Optimize (Sharpe)',
        generate: 'Generate Portfolio',
        validationError: 'Select at least 2 strategies and ensure weights total 100%',
        optimizeSuccess: 'Portfolio optimized with expected Sharpe:',
        optimizeError: 'Error optimizing portfolio',
      },
      modelsSection: {
        title: 'Model Portfolios',
        subtitle: 'Pre-configured portfolios for different risk profiles',
        usePortfolio: 'Use This Portfolio',
        questionnaire: 'Take Questionnaire',
      },
      savedSection: {
        title: 'Saved Portfolios',
        subtitle: 'Access your previously saved portfolio configurations',
        noSaved: 'No saved portfolios yet',
        load: 'Load',
        delete: 'Delete',
      },
      results: {
        title: 'Portfolio Results',
        composition: 'Portfolio Composition',
        metrics: 'Key Metrics',
        performance: 'Historical Performance',
        returns: 'Monthly Returns',
        exportPDF: 'Download Portfolio Report',
        save: 'Save Portfolio',
        saveSuccess: 'Portfolio saved successfully!',
        saveError: 'Error saving portfolio',
        period: 'Period',
        strategies: 'Strategies',
        tabs: {
          equity: 'Equity Curve',
          drawdown: 'Drawdown',
          annual: 'Annual Returns',
        },
        metricLabels: {
          cagr: 'CAGR',
          totalReturn: 'Total Return',
          sharpe: 'Sharpe',
          sortino: 'Sortino',
          maxDD: 'Max DD',
          calmar: 'Calmar',
          volatility: 'Volatility',
          winRate: 'Win Rate',
          profitFactor: 'Profit Factor',
          bestWeek: 'Best Week',
          worstWeek: 'Worst Week',
        },
        quickStart: {
          model: 'Model Portfolio',
          modelDesc: 'Answer 5 questions and this tool will suggest a model portfolio based on your risk tolerance',
          models: 'Model Portfolios',
          modelsDesc: 'Choose from 6 expert-designed portfolios: Conservative, Moderate, Aggressive, and more',
          auto: 'Auto Optimization',
          autoDesc: 'Algorithm finds optimal weights to maximize Sharpe Ratio automatically',
        },
        manual: {
          title: 'Manual Builder',
          selectTitle: 'Select Strategies and Assign Weights',
        },
      },
    },

    // Insights Page
    insights: {
      title: 'Insights',
      subtitle: 'Strategies, analysis and resources to invest intelligently',
      substackSection: {
        title: 'LATEST FROM SUBSTACK',
        loading: 'Loading latest posts...',
        error: 'Failed to load articles. Please try again later.',
        errorWithLink: 'Recent articles on Substack:',
      },
      newsletterTitle: 'HMA Quant Newsletter',
      visitSubstack: 'Visit my Substack',
      weeklyNewsletter: 'Weekly Newsletter',
      analysisAndNewsletter: 'Analysis & Newsletter',
      subscribe: 'Subscribe',
      newsletterIntro: 'I share quantitative analysis, investment theses and daily notes on the S&P500 options map on my Substack',
      newsletterDescription: 'Receive deep technical analysis, quantitative investment theses and the daily S&P500 options map directly in your email. Exclusive content for traders seeking informational advantage.',
      newsletterBadge1: 'Quantitative Analysis',
      newsletterBadge2: 'Options Map',
      newsletterBadge3: 'Investment Theses',
      whereToInvestTitle: 'Where to Invest',
      whereToInvestSubtitle: 'You can follow my quantitative strategies on the following regulated platforms. Each strategy has its own risk-return profile and is available for copy-trading or direct investment.',
      darwinex: {
        title: 'Darwinex',
        description: 'FCA-regulated platform for copy-trading algorithmic strategies',
        strategies: 'Strategies',
      },
      etoro: {
        title: 'eToro',
        description: 'Social trading platform with millions of users worldwide',
        profile: 'My Profile',
      },
      wikifolio: {
        title: 'Wikifolio',
        description: 'European platform for investable strategy certificates',
        profile: 'My Profile',
      },
      resourcesTitle: 'Educational Resources',
      resourcesSubtitle: 'Articles, tools and guides to improve your quantitative investing',
      comingSoon: 'Coming soon',
    },


    // Weekly Reports Page
    weeklyReports: {
      title: 'Weekly Quantitative Reports',
      subtitle: 'Subscribe to in-depth quantitative research for each strategy. Every report provides a deep dive into the mathematical framework, weekly model developments, portfolio movements, and the quantitative reasoning behind each strategy\'s evolution.',
      subscriptionOptions: 'Subscription Options',
      pricePerMonth: '€{price}/month',
      subscribe: 'Subscribe',
      manage: 'Manage Subscription',
      alreadySubscribed: 'Already Subscribed',
      signInToSubscribe: 'Sign in to subscribe',
      statusActive: 'Active',
      statusCancelling: 'Cancels on {date}',
      statusExpired: 'Expired',
      billingMonthly: 'Monthly billing',
      cancelAnytime: 'Cancel anytime',
      availableOnBrokers: 'Available on all major brokers',
      assetsLabel: 'Assets:',
      whatYouGet: 'What you get:',
      subscribers: '{count} subscribers',
      loading: 'Loading...',
      errorLoading: 'Failed to load',
      subscribeTo: 'Subscribe to',
      subscribed: 'Subscribed',
      cancelsOn: 'Cancels on',
      completeBundle: 'Complete Bundle',
      completeBundleDesc: 'All strategies + Market reports + Quant Macro Insights',
      bestValue: 'BEST VALUE',
      perMonth: '/month',
      perYear: '/year',
      planMonthly: 'Monthly',
      planAnnual: 'Annual',
      twoMonthsFree: '2 months free',
      equivMonthly: 'equiv. €{price}/month',
      savingsText: '(€479.92 individually — save €184.93 + macro content)',
      savingsTextAnnual: '(€4,799.92 individually — save €1,849.93 + macro content)',
      getFullAccess: 'Get Full Access',
      includes: 'Includes:',
      bundleIncludes: {
        strategies: 'All 22 strategies (TYR, HRÆSVELGR, ARES, JANUS, BES, FOBOS, DEIMOS, ASCÁLAFO, EOS, ARTEMIS, HELIOS, HYPERION, HORAI, THEIA, ASTRAEUS, PHAETHON, HEMERA, SELENE, ASTERIA, AETHER, HEIMDALL, METIS)',
        weeklyReports: 'Weekly reports with full analysis',
        macroInsights: 'Quantitative macroeconomic insights',
        historicalAccess: 'Full historical archive access',
        transparentSignals: 'Signals with transparent reasoning',
      },
    },

    // Terminal Page
    terminal: {
      title: 'Terminal',
      watchlist_title: 'Watchlist',
      add_ticker_placeholder: 'Type ticker + Enter',
      col_symbol: 'Symbol',
      col_price: 'Price',
      col_change: 'Chg',
      col_change_pct: 'Chg %',
      col_volume: 'Volume',
      col_day_range: 'Day Range',
      footer_text: 'DATA: YAHOO FINANCE · DELAYED 15 MIN · FOR EDUCATIONAL USE ONLY',
    },


    // Contact Page
    contact: {
      title: 'Let\'s Talk',
      subtitle: 'Interested in quantitative strategies, collaborations, or hiring opportunities? Contact me.',
      formTitle: 'Send Me a Message',
      formName: 'Name',
      formEmail: 'Email',
      formMessage: 'Message',
      formSubmit: 'Send Message',
      infoTitle: 'Contact Information',
      emailLabel: 'Email',
      emailLocked: 'Send your email above to unlock',
      linkedinLabel: 'LinkedIn',
      substackLabel: 'Substack',
    },

    // Returns Calculator Component
    calculator: {
      title: 'RETURNS CALCULATOR',
      subtitle: 'Calculate how much you would have earned investing in',
      historicalData: 'with real historical data',
      initialInvestment: 'Initial Investment',
      monthlyContribution: 'Monthly Contribution (Optional)',
      calculate: 'Calculate Returns',
      results: {
        finalValue: 'FINAL VALUE',
        totalGain: 'TOTAL GAIN',
        returnPercent: 'RETURN %',
        summary: 'Summary:',
        summaryText1: 'With an initial investment of',
        summaryText2: 'and monthly contributions of',
        summaryText3: ', you would have invested a total of',
        summaryText4: 'over',
        summaryText5: ', obtaining a final value of',
        years: 'years',
      },
    },

    // Footer
    footer: {
      rights: 'All rights reserved',
      disclaimer: 'Past performance does not guarantee future results. Trading involves risk.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      legal: 'Legal Notice',
    },

    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      viewMore: 'View More',
      learnMore: 'Learn More',
      backToTop: 'Back to Top',
      downloadBrochure: 'Download Brochure',
    },

    // Terminal Page
    terminal: {
      // General
      quantLab: 'Quant Lab',
      marketData: 'Market Data',
      derivatives: 'Derivatives',
      signals: 'Signals',
      research: 'Research',
      controls: 'Controls',
      statistics: 'Statistics',
      numPaths: 'Number of Paths',
      seed: 'Random Seed',
      showPaths: 'Show Paths',
      showMean: 'Show Mean',
      showDistribution: 'Show Distribution',
      showRegimes: 'Color by Regime',
      terminalMean: 'Terminal Mean',
      terminalStd: 'Terminal Std Dev',
      theoreticalMean: 'Theoretical Mean',
      theoreticalStd: 'Theoretical Std',
      stationaryMean: 'Stationary Mean',
      stationaryStd: 'Stationary Std',
      pricePaths: 'Price Paths',
      meanReversion: 'Mean Reversion Process',
      terminalDistribution: 'Terminal Distribution',
      priceWithRegimes: 'Price Path with Market Regimes',
      regimeStats: 'Regime Statistics',
      comingSoon: 'Coming Soon',
      footer: 'Educational tool for stochastic process simulation',
      
      // Modules
      macroTerminal: 'Macro Terminal',
      watchlist: 'Watchlist',
      charts: 'Charts',
      heatmap: 'Market Heatmap',
      optionsPricing: 'Options Pricing',
      greeks: 'Greeks Calculator',
      volatilitySurface: 'Volatility Surface',
      liveSignals: 'Live Signals',
      backtest: 'Backtest Engine',
      economicCalendar: 'Economic Calendar',
      newsAnalysis: 'News Analysis',

      // GBM
      gbm: {
        name: 'Geometric Brownian Motion',
        title: 'Geometric Brownian Motion',
        subtitle: 'Classic model for stock price dynamics with constant drift and volatility',
        whatIs: 'What is this?',
        whatIsContent: 'A mathematical recipe for generating random stock price paths. It assumes the price moves by a constant average growth rate (drift) plus random noise proportional to the current price (volatility). Simple, unrealistic, and absolutely foundational.',
        whyMatters: 'Why does it matter in finance?',
        whyMattersContent: 'Every option pricing textbook starts here. It\'s the model behind the Nobel-winning Black-Scholes formula. It tells us how stock returns would behave if the world were "normal" (literally — returns are normally distributed under GBM). Real markets are messier: volatility changes, crashes happen, returns have fat tails. But every more sophisticated model builds on GBM or tests itself against it.',
        symbolsTitle: 'What each symbol means',
        symbols: {
          st: 'the stock price at time t',
          mu: 'annualized expected return (drift)',
          sigma: 'annualized volatility',
          dt: 'an infinitesimal slice of time',
          dwt: 'a tiny random shock drawn from a Gaussian (Brownian motion)',
        },
        chartGuide: 'How to read the chart',
        chartGuideContent: 'The x-axis is time in years. Each colored line is one simulated future for the stock price. The thick pink line is the average across all simulations. The histogram below shows the distribution of FINAL prices (at time T) across all simulated paths — should look log-normal.',
        playWith: 'Play with it',
        experiments: [
          'Set σ to 0.01 (almost no volatility): paths become near-deterministic. The stock just grows exponentially at rate μ.',
          'Set σ to 0.80 (very high volatility): paths spread wildly. Some paths crash to zero.',
          'Set μ to a negative number: the stock drifts down on average, but paths can still rally due to noise.',
          'Compare Paths=1 vs Paths=100: single paths look stochastic; averages across 100 look smooth. This is the Law of Large Numbers in action.',
        ],
        inStrategies: 'In our strategies',
        inStrategiesContent: 'GBM is the baseline assumption we test every strategy against. If a strategy makes money on GBM data, that\'s suspicious — GBM has no exploitable structure by design. Any "backtest profit" on pure GBM is either a bug, overfitting, or curve fitting. Strategies like FOBOS actively exploit how real markets deviate from GBM: real volatility clusters, real returns are fat-tailed, real crashes cluster in time.',
      },

      // Ornstein-Uhlenbeck
      ou: {
        name: 'Ornstein-Uhlenbeck',
        title: 'Ornstein-Uhlenbeck Process',
        subtitle: 'Mean-reverting process used for interest rates, volatility, and pairs trading',
        whatIs: 'What is this?',
        whatIsContent: 'A process that wanders randomly, like GBM, but with a crucial twist: it gets pulled back toward a long-run average. The further it strays, the stronger the pull. Think of it as a stock price on a rubber band — noise stretches it, but the rubber band always reels it back.',
        whyMatters: 'Why does it matter in finance?',
        whyMattersContent: 'Single stock prices don\'t usually mean-revert (if a stock is worth €100 today, there\'s no reason it must come back to €80 tomorrow). But spreads between related assets often do. Two similar ETFs, two stocks in the same industry, two bond yields: their difference tends to oscillate around an equilibrium. OU models that oscillation. If we can estimate the pull strength (κ) and the equilibrium (μ), we know when the spread is stretched enough to bet on reversion.',
        symbolsTitle: 'What each symbol means',
        symbols: {
          xt: 'the value of the spread at time t',
          kappa: 'mean reversion speed. Higher = snaps back faster',
          mu: 'the long-run equilibrium level',
          sigma: 'noise level (volatility)',
          dwt: 'the random Brownian shock',
        },
        halfLife: 'Key insight — half-life',
        halfLifeContent: 'The characteristic time for a shock to decay by half is ln(2) / κ. If κ = 2, half-life ≈ 0.35 years (4 months). A shock today loses half its magnitude in 4 months. If κ = 0.1, half-life ≈ 7 years — the spread drifts so slowly that betting on reversion is pointless.',
        chartGuide: 'How to read the chart',
        chartGuideContent: 'The main chart shows the spread X_t over time. The horizontal dashed orange line is the long-run mean μ. Notice how the process wanders but always gets yanked back. The histogram shows the stationary distribution (where X spends most of its time): it\'s Gaussian, centered on μ, with variance σ² / (2κ).',
        playWith: 'Play with it',
        experiments: [
          'Start X₀ far from μ (e.g. X₀ = 4, μ = 0): watch how fast it gets pulled back. With κ high, it\'s decisive. With κ low, it takes forever.',
          'Set κ = 0: the mean-reversion disappears. X drifts randomly. This is equivalent to Brownian motion with drift.',
          'Set σ very low and κ high: X quickly converges to μ and stays almost stuck there.',
          'Set σ very high and κ low: X wanders huge distances. The stationary distribution is wide.',
        ],
        inStrategies: 'In our strategies',
        inStrategiesContent: 'This is literally the math behind ARES. When we detect a potentially cointegrated pair of ETFs, we fit OU to their spread. Then we ask: is κ high enough that reversion happens in days, not months? Is the spread currently more than 2 standard deviations from μ? Both conditions met → we take the trade. κ too low or spread near μ → we pass.',
      },

      // Greeks Explorer
      greeksExplorer: {
        name: 'Greeks Explorer',
        title: 'GREEKS · OPTION SENSITIVITIES',
        subtitle: 'How the option price moves when the inputs move',
        intro: 'The Greeks are partial derivatives of the Black-Scholes formula. Each tells you how the option price responds to a change in one input. Professional traders don\'t look at option prices — they look at Greeks. A portfolio with Delta = 0 is "delta-neutral" — immune to small moves in the underlying. A portfolio with positive Gamma is "long convexity" — it benefits from any large move up or down. Understanding Greeks is understanding how options actually work.',
        introTitle: 'Introduction',
        introContent: 'The Greeks are partial derivatives of the Black-Scholes formula. Each tells you how the option price responds to a change in one input. Professional traders don\'t look at option prices — they look at Greeks. A portfolio with Delta = 0 is "delta-neutral" — immune to small moves in the underlying. A portfolio with positive Gamma is "long convexity" — it benefits from any large move up or down. Understanding Greeks is understanding how options actually work.',
        controls: 'Controls',
        currentGreeks: 'Current Greeks',
        callOption: 'CALL OPTION',
        putOption: 'PUT OPTION',
        price: 'PRICE',
        labels: {
          spotPrice: 'S (Spot Price)',
          strike: 'K (Strike)',
          timeToExpiry: 'T (Time to Expiry, years)',
          riskFreeRate: 'r (Risk-Free Rate)',
          volatility: 'σ (Volatility)',
        },
        delta: {
          name: 'Δ (DELTA)',
          title: 'Δ (DELTA) · ∂V/∂S',
          description: 'Delta is the hedge ratio. A call with delta 0.5 means we short 0.5 shares to hedge 1 option. Delta ranges from 0 to 1 for calls, -1 to 0 for puts.',
          formula: 'Formula',
          formulaNote: 'where Φ is the standard normal cumulative distribution function, and d₁ = [ln(S/K) + (r + σ²/2)T] / (σ√T)',
        },
        gamma: {
          name: 'Γ (GAMMA)',
          title: 'Γ (GAMMA) · ∂²V/∂S² = ∂Δ/∂S',
          description: 'Gamma measures how fast delta changes. High gamma = delta flips violently with small price moves. ATM options have the highest gamma.',
          formula: 'Formula',
          formulaNote: 'where φ is the standard normal probability density function: φ(x) = (1/√(2π)) exp(-x²/2)',
        },
        vega: {
          name: 'V (VEGA)',
          title: 'V (VEGA) · ∂V/∂σ',
          description: 'Vega measures sensitivity to volatility. Long options = long volatility. If σ rises by 1%, option price rises by Vega.',
          formula: 'Formula',
          formulaNote: 'Vega is the same for calls and puts. Shown per 1% change in volatility.',
        },
        theta: {
          name: 'Θ (THETA)',
          title: 'Θ (THETA) · -∂V/∂t',
          description: 'Theta is time decay. Long options lose value as time passes (negative theta). Short options benefit (positive theta) — the cornerstone of volatility selling.',
          formula: 'Formula',
          formulaNote: 'Shown per day. Theta is typically negative for long options (time decay).',
        },
        rho: {
          name: 'ρ (RHO)',
          title: 'ρ (RHO) · ∂V/∂r',
          description: 'Rho measures interest rate sensitivity. For short-dated options, rho is small. For LEAPS, it can matter a lot.',
          formula: 'Formula',
          formulaNote: 'Shown per 1% change in risk-free rate.',
        },
        inStrategies: 'How HMA uses this',
        fobosStrategy: 'FOBOS actively trades volatility via options. The key Greek for FOBOS is Vega — when implied volatility is rich relative to realized, FOBOS sells options to harvest premium (negative Vega). When implied vol crashes below realized, FOBOS buys convexity via long Gamma.',
        ascalafoStrategy: 'ASCÁLAFO runs systematic option strategies where Theta and Gamma dominate. Theta is the "yield" from selling time, but Gamma is the risk — a fat move wipes out weeks of theta collection. The art is sizing positions so Theta/Gamma ratio is worth the risk.',
      },

      // Black-Scholes Derivation
      bsDerivation: {
        name: 'Black-Scholes Derivation',
        title: 'BLACK-SCHOLES · FROM FIRST PRINCIPLES',
        subtitle: 'How an equation worth a Nobel Prize is actually built',
        tabs: {
          tab1: '01 · THE PROBLEM',
          tab2: '02 · BINOMIAL',
          tab3: '03 · REPLICATION',
          tab4: '04 · CONTINUOUS',
          tab5: '05 · THE PDE',
          tab6: '06 · FORMULA',
        },
        previous: 'PREVIOUS',
        next: 'NEXT',
        common: {
          stockPrice: 'Stock Price',
          strike: 'K',
          strikePrice: 'Strike Price',
          spotPrice: 'Spot Price',
          timeToExpiry: 'Time to Expiry',
          riskFreeRate: 'Risk-Free Rate',
          volatility: 'Volatility',
          initialPrice: 'Initial Price',
          upFactor: 'Up Factor',
          downFactor: 'Down Factor',
          timeStep: 'Time Step',
          numberSteps: 'Number of Steps',
          years: 'y',
        },
        tab1: {
          whatIsOption: 'What\'s an option?',
          whatIsOptionContent: 'A European call option gives you the right (not obligation) to BUY an asset at a fixed price K on a fixed date T. If the asset price S_T at expiry is above K, you exercise and pocket S_T - K. If below, you walk away with zero.',
          payoffFunction: 'The Payoff Function',
          payoffDesc: 'At expiry, the option is worth its intrinsic value: the difference between spot and strike, or zero.',
          interactivePayoff: 'Interactive Payoff Diagram',
          stockPriceAtExpiry: 'Stock Price at Expiry',
          payoff: 'Payoff',
          callPayoff: 'Call Payoff',
          hockeyStick: 'The hockey-stick shape: zero below K, linear above K. The dashed line shows the strike.',
          theQuestion: 'The Question Black-Scholes Answers',
          questionText: 'How much should we pay TODAY for the right to receive max(S_T - K, 0) TOMORROW?',
          questionExplanation: 'The payoff is KNOWN given S_T. The problem is we don\'t know S_T. Black-Scholes shows us how to hedge the uncertainty away completely — under idealized assumptions — and thereby pin down the option\'s fair price.',
          assumptions: 'Assumptions',
          assumptionsList: [
            'The stock follows Geometric Brownian Motion (see the GBM module)',
            'Constant volatility σ',
            'Constant risk-free rate r',
            'No dividends, no transaction costs, no taxes',
            'Continuous trading, perfect liquidity',
            'European exercise (only at T, not before)',
          ],
        },
        tab2: {
          simplestUniverse: 'The simplest possible universe',
          simplestUniverseContent: 'One time step. The stock is S₀ today. At time Δt it goes up to S_u = S₀·u (with probability p) or down to S_d = S₀·d (with probability 1-p).',
          binomialTreeParams: 'Binomial Tree Parameters',
          treeValues: 'Tree Values',
          up: 'UP',
          down: 'DOWN',
          payoffUp: 'Payoff Up',
          payoffDown: 'Payoff Down',
          wrongApproach: 'The WRONG approach (naive probability)',
          wrongApproachText: 'Simply taking the probability-weighted average gives:',
          wrongApproachWarning: 'BUT WAIT — this is wrong. The real p doesn\'t matter. The market doesn\'t price options by "expected payoff under real probability". It prices them by REPLICATION.',
        },
        tab3: {
          centralIdea: 'The central idea',
          centralIdeaContent: 'Instead of guessing probabilities, construct a portfolio of stock + cash that gives the SAME payoff as the option in both scenarios. By no-arbitrage, the cost of that portfolio today must equal the option price.',
          replicationPortfolio: 'Replication Portfolio',
          replicationDesc: 'Portfolio = Δ shares of stock + B cash (borrowed or invested at rate r)',
          solvingSystem: 'Solving the System',
          hedgeRatio: 'HEDGE RATIO',
          cash: 'CASH',
          optionPrice: 'OPTION PRICE',
          riskNeutralProb: 'Risk-Neutral Probability',
          riskNeutralText1: 'After algebra, this simplifies to:',
          riskNeutralText2: 'where the RISK-NEUTRAL PROBABILITY is:',
          profoundPoint: 'The profound point:',
          profoundText: 'Notice: the real-world probability p never appeared. The option price only depends on u, d, r, Δt, K. This is the magic of risk-neutral pricing — we replace real probabilities with risk-neutral ones, discount by the risk-free rate, and arrive at the arbitrage-free price.',
          riskNeutralQ: 'Risk-Neutral q:',
          discountedPrice: 'Discounted Price:',
        },
        tab4: {
          nStepIntro: 'N-step tree → Continuous time',
          nStepContent: 'Extend the binomial tree to N steps between 0 and T. As N → ∞, with properly chosen u and d, the tree converges to GBM.',
          crrParams: 'Cox-Ross-Rubinstein Parameters',
          crrExplanation: 'With these choices, the binomial tree matches the first two moments of GBM and converges to the continuous-time limit as N grows.',
          convergenceTitle: 'Convergence to Black-Scholes',
          convergenceChart: 'As N grows, the binomial tree price converges to the Black-Scholes price.',
          continuousLimit: 'The Continuous-Time Limit',
          continuousLimitContent: 'As N → ∞ and Δt → 0, the binomial tree becomes GBM, and the risk-neutral discrete-time pricing becomes the Black-Scholes continuous-time pricing. But we need a cleaner tool: the PDE.',
        },
        tab5: {
          derivationIntro: 'Derivation from Stochastic Calculus',
          derivationContent: 'Stock follows GBM under risk-neutral measure Q:',
          itosLemma: 'Itô\'s Lemma',
          itosContent: 'Consider an option V(S, t). By Itô\'s lemma:',
          hedgePortfolio: 'The Hedge Portfolio',
          hedgeContent: 'Portfolio Π = V - Δ·S where Δ = ∂V/∂S. The dW term cancels! Π becomes deterministic.',
          noArbitrage: 'No-Arbitrage Condition',
          noArbitrageContent: 'A deterministic portfolio must earn the risk-free rate:',
          noArbitrageExplanation: 'Equating this to the Itô expansion of Π gives the Black-Scholes PDE:',
          bsPDE: 'The Black-Scholes PDE',
          boundaryConditions: 'Boundary Conditions',
          boundaryContent: 'For a European call:',
          boundaryList: [
            'V(S, T) = max(S - K, 0) at expiry',
            'V(0, t) = 0 for all t',
            'V(S, t) → S - K·e^(-r(T-t)) as S → ∞',
          ],
          keyInsight: 'Key insight:',
          keyInsightContent: 'This is a parabolic PDE — the same mathematical form as the heat equation in physics. And like the heat equation, it has a closed-form solution when the boundary condition is the call option\'s payoff. That solution is the Black-Scholes formula.',
        },
        tab6: {
          closedFormIntro: 'The Closed-Form Formula',
          closedFormContent: 'Through a change of variables (log-price, reversed time, normalized V), the Black-Scholes PDE maps exactly to the heat equation. The heat equation has a known Gaussian fundamental solution, which when transformed back gives:',
          bsFormulaCall: 'Black-Scholes Formula for European Call',
          bsFormulaWhere: 'where Φ is the standard normal CDF, and:',
          interactiveCalc: 'Interactive Calculator',
          callPrice: 'CALL PRICE',
          putPrice: 'PUT PRICE',
          priceVsSpot: 'Price vs Spot · Time Value Decomposition',
          bsPrice: 'BS Price',
          intrinsicValue: 'Intrinsic Value',
          priceChartDesc: 'Solid line: BS price. Dashed line: intrinsic value max(S-K, 0). The gap is time value.',
          impact: 'The Impact',
          impactContent: 'Black and Scholes (and Merton) published this in 1973. Merton won the Nobel in 1997. This one equation changed finance forever. Everything after — stochastic volatility, jump diffusions, local vol, SABR, rough vol — is an attempt to fix its flaws. But the scaffolding is the same: replicate, no-arbitrage, risk-neutral measure, PDE, expectation.',
          greeksNext: 'The next module (Greeks Explorer) shows the partial derivatives of this formula. Delta is ∂C/∂S. Gamma is ∂²C/∂S². Theta is -∂C/∂t. Vega is ∂C/∂σ. Rho is ∂C/∂r. Each one tells you how the price reacts to a different input.',
        },
      },

      // Regime Switching
      regime: {
        name: 'Regime Switching',
        title: 'Regime Switching Model',
        subtitle: 'Market behavior changes across bull, neutral, and bear regimes',
        whatIs: 'What is this?',
        whatIsContent: 'Real markets don\'t behave the same way all the time. There are calm trending periods where momentum strategies print money. Choppy range-bound periods where mean reversion works. Crisis periods where correlations break, volatility explodes, and everything goes to cash. A regime-switching model says: instead of ONE set of parameters (μ, σ) for the whole market, there are N sets, and the market randomly switches between them according to a transition matrix.',
        whyMatters: 'Why does it matter in finance?',
        whyMattersContent: 'A strategy optimized on 2017 data (low-vol trending) and deployed in 2020 (COVID crash) is a disaster. Parameters that were optimal in one regime can be catastrophic in another. Regime-aware strategies do two things: detect the current regime in real time, and allocate capital to sub-strategies that fit that regime. This is what separates a naive backtest from something resilient.',
        symbolsTitle: 'What each symbol means',
        symbols: {
          st: 'the hidden regime at time t (Bull, Neutral, or Bear)',
          a: 'the transition probability matrix. A[i][j] = probability of jumping from regime i to regime j',
          mui: 'expected return in regime i (annualized)',
          sigmai: 'volatility in regime i (annualized)',
        },
        chartGuide: 'How to read the chart',
        chartGuideContent: 'The price line shows the simulated asset price. The colored dots show which regime was active at each time: Green = Bull (high μ, low σ), Yellow = Neutral (neutral μ, medium σ), Red = Bear (negative μ, high σ). Stats show what fraction of the simulation was spent in each regime.',
        playWith: 'Play with it',
        experiments: [
          'Make Persistence very high (e.g. 0.97): regimes are "sticky" — once you\'re in one, you tend to stay. Realistic.',
          'Make Persistence very low (e.g. 0.3): regimes flicker rapidly. Unrealistic but illustrative.',
          'Set Bear μ to -0.70: deep crisis drags the price hard. See how the regime mix determines the overall trajectory.',
          'Run several simulations: even with the same parameters, different random seeds give dramatically different price paths, because regime sequences differ.',
        ],
        inStrategies: 'In our strategies',
        inStrategiesContent: 'DEIMOS runs a Hidden Markov Model in real time. It doesn\'t see the regime directly — it observes returns, volatility, and correlations, and infers which regime is most likely. When DEIMOS says "we\'re in Crisis", the whole platform reduces exposure automatically. Other strategies use regime detection as a filter: BES only buys stocks when DEIMOS says "Trending". FOBOS hedges aggressively when DEIMOS says "Crisis". This is why the strategies have near-zero correlation to the S&P — they\'re not just long equities with leverage, they\'re regime-aware.',
      },
    },
};
